// extracted by mini-css-extract-plugin
module.exports = {"container":"IconTitleText_container__NQ0ta","image-container":"IconTitleText_image-container__1LfVd","title-body-container":"IconTitleText_title-body-container__v5r_W"};